import { useQuery } from "@tanstack/react-query";
import { GetLocationParams } from "./location.types";
import { LOCATION_KEYS } from "./location.keys";
import { locationServices } from "./location.services";

export const useGetLocations = (params?: GetLocationParams) => {
  return useQuery({
    queryKey: LOCATION_KEYS.GET_LOCATIONS(params),
    queryFn: () => locationServices.getLocations(params),
  });
};

export const useGetStorageSettings = () => {
  return useQuery({
    queryKey: LOCATION_KEYS.GET_STORAGE_SETTINGS(),
    queryFn: () => locationServices.getStorageSettings(),
  });
};